import { data } from '../../svg/Summary/data';
import { makeIcon } from '../makeIcon';

export const Summary = makeIcon(data, 'summary', 'Summary');

export default Summary;
